import { metaAccount } from '@/router/meta-config'
const permissionKey = 'BLOGCATEGORY'

export default [
  {
    path: '/blog-categories',
    name: 'page-blog-categories',
    component: () => import('@/pages/blogCategories'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/blog-category/new',
    name: 'page-blog-category-new',
    component: () => import('@/pages/blogCategory'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/blog-category/:id',
    name: 'page-blog-category',
    component: () => import('@/pages/blogCategory'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
